import client from '../helpers/Client';

const productService = {
  async getProducts(params = {}) {
    try {
      const response = await client.get('/models/', { params });
      return response.data;
    } catch (error) {
      console.error('Ürünler çekilirken hata:', error);
      throw error;
    }
  },
  async getModels(params = {}) {
    try {
      const response = await client.get('/models/', { params });
      return response.data;
    } catch (error) {
      console.error('Ürün modelleri çekilirken hata:', error);
      throw error;
    }
  }
};

export default productService;